import { P, ToolTip } from "../../../../AbstractElements";
import { danger, locationIcon, NA } from "../../../../utils/Constant";
import { convertTo12HourFormat } from "../../../../utils/timeUtils";
import IconComponent from "../../../../CommonElements/IconComponent";
import BadgeDetails from "../../../../CommonElements/Badge/BadgeDetails";

const LocationTimeCell = ({
  time,
  location,
  tooltipId,
  showTooltip,
  toggleTooltip,
  clean = false,
}: {
  time: string;
  location: string;
  tooltipId: string;
  showTooltip: boolean;
  toggleTooltip: () => void;
  clean?: boolean;
}) => (
  <div className="w-100 d-flex align-items-center">
    {time ? <P className="m-0 f-12">{convertTo12HourFormat(time)}</P> : clean ? <span className="text-muted">–</span> : null}
    {location ? (
      <div
        id={tooltipId}
        onMouseEnter={toggleTooltip}
        onMouseLeave={toggleTooltip}
      >
        <IconComponent className={`${locationIcon} ${clean ? "text-muted f-12 ms-2" : "text-danger f-18"}`} />
        <ToolTip target={tooltipId} placement="top" isOpen={showTooltip}>
          {location}
        </ToolTip>
      </div>
    ) : (
      clean ? null : <BadgeDetails
        color={danger}
        className="badget-primary rounded-pill"
        text={NA}
      />
    )}
  </div>
);

export default LocationTimeCell;
